import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { filter } from 'lodash'
import { useProjectsSafe } from '../../contexts/ProjectsContext'

function usePendingChangesProjects() {
  const { teamSlug } = useParams()
  const { projects, loading, reload } = useProjectsSafe()

  const pendingProjects = useMemo(
    () => filter(projects, { pendingChanges: true }),
    [projects]
  )

  return {
    projects: pendingProjects,
    pendingChangesCount: pendingProjects.length,
    loading,
    reload,
    teamSlug,
  }
}

export default usePendingChangesProjects
